import { convertPxToRem } from "@/utils";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DefaultDialog from "@/features/Common/components/DefaultDialog";
import IconLoader from "@/features/Common/components/IconLoader";

interface FaceScanSuccessDialogProps {
  onDismiss?: () => void;
}

export default function FaceScanSuccessDialog({
  onDismiss,
}: FaceScanSuccessDialogProps) {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const DIALOG_DISMISS_TIMER = 5000; // 5 seconds

  const dialogTitle = t("BinahFaceScanSuccess.emailMyResults.success.title");
  const dialogBody = t("BinahFaceScanSuccess.emailMyResults.success.body");

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDialogOpen(false);
      onDismiss?.();
    }, DIALOG_DISMISS_TIMER);

    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <DefaultDialog
      isOpen={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
      fullWidth
    >
      <IconLoader
        icon="FaceInverseIcon"
        color="primary"
        sx={{ fontSize: convertPxToRem(56), alignSelf: "center" }}
      />

      <Typography variant="h3" fontWeight={600} align="center">
        {dialogTitle}
      </Typography>
      <Typography align="center">{dialogBody}</Typography>
    </DefaultDialog>
  );
}
